// THIS FILE IS AUTOGENERATED. DO NOT EDIT MANUALLY.

import age_id_check from './age_id_check/problem.json';
import calculate_euclidean_distance from './calculate_euclidean_distance/problem.json';
import calculate_square_area from './calculate_square_area/problem.json';
import first_middle_last_string from './first_middle_last_string/problem.json';
import has_one from './has_one/problem.json';
import index_safety_check from './index_safety_check/problem.json';
import middle_character from './middle_character/problem.json';
import old_enough_for from './old_enough_for/problem.json';
import first_last_list from './remove_first_last_list/problem.json';
import roots from './roots/problem.json';
import valid_email_check from './valid_email_check/problem.json';
const problems = [
    age_id_check,
    calculate_euclidean_distance,
    calculate_square_area,
    first_middle_last_string,
    has_one,
    index_safety_check,
    middle_character,
    old_enough_for,
    first_last_list,
    roots,
    valid_email_check,
];
export default problems;
